import React, { useEffect } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import CaseStudies from '@/components/CaseStudies';
import TrustBadges from '@/components/TrustBadges';
import CallToAction from '@/components/CallToAction';
import { useLanguage } from '@/contexts/LanguageContext';

const CaseStudiesPage = () => {
  const { currentLanguage } = useLanguage();

  useEffect(() => {
    // Update page title and meta description
    document.title = currentLanguage === 'de' 
      ? 'Erfolgsgeschichten | Future Level' 
      : currentLanguage === 'fr'
      ? 'Études de cas | Future Level'
      : currentLanguage === 'it'
      ? 'Studi di caso | Future Level'
      : 'Case Studies | Future Level';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      const description = currentLanguage === 'de'
        ? 'Bewiesene Resultate für Schweizer KMU. Echte Projekte, messbare Erfolge mit AI-Videos und digitalem Marketing.'
        : currentLanguage === 'fr'
        ? 'Résultats prouvés pour les PME suisses. Projets réels, succès mesurables avec vidéos IA et marketing digital.'
        : currentLanguage === 'it'
        ? 'Risultati comprovati per PMI svizzere. Progetti reali, successi misurabili con video IA e marketing digitale.'
        : 'Proven results for Swiss SMEs. Real projects, measurable success with AI videos and digital marketing.';
      metaDescription.setAttribute('content', description);
    }
  }, [currentLanguage]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <div className="pt-20">
          <CaseStudies />
          <div className="py-12 bg-background/50">
            <div className="container mx-auto px-4 text-center">
              <TrustBadges />
            </div>
          </div>
          <CallToAction />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CaseStudiesPage;